import Rest from '../Server/Rest';
import config from '../settings/config';

const getCurrentPercentage = () => {
  return new Promise((resolve, reject) => {
    const params = new URLSearchParams({
      where: JSON.stringify({ activo: true }),
      count: '1',
      limit: '1',
    });

    Rest.peticion(
      `${
        config.api_url
      }/classes/SistemaPorcentajeMorosidad?${params.toString()}`,
      {
        method: 'GET',
      }
    )
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else {
          throw new Error('Error fetching percentage');
        }
      })
      .then((response) => {
        resolve({
          percentageDelinquency: response.results.length
            ? response.results[0].porcentaje
            : 0,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getParseAppConfig = () => {
  return new Promise((resolve, reject) => {
    Rest.peticion(`${config.api_url}/config`, {
      method: 'GET',
    })
      .then((res) => {
        return res.json();
      })
      .then((res) => {
        resolve(res.params);
      })
      .catch((error) => reject(error));
  });
};

const getConfig = () => {
  return new Promise((resolve, reject) => {
    Promise.all([getCurrentPercentage(), getParseAppConfig()])
      .then(([percentageData, appConfig]) => {
        resolve({
          ...(appConfig || {}),
          ...(percentageData || {}),
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export default getConfig;
